
import { PrimaryModelsClient } from "./client";

export async function getDatabaseForDevPurposes() {
  if (process.env["NODE_ENV"] !== "development") {
    throw new Error("This function is only available in development mode");
  }

  if (!process.env["DEV_TOOLS_PRIMARY_DATABASE_URL_PROD"] || !process.env["DEV_TOOLS_PRIMARY_DATABASE_URL_DEV"]) {
    throw new Error("Primary database URLs are not set. Please note that under no circumstances should a writable connection be used with the production database. Read-only connection URL starts with `aux_read_only`");
  }

  if (!process.env["DEV_TOOLS_PERSONAL_USER_EMAIL_PROD"] || !process.env["DEV_TOOLS_PERSONAL_USER_ID_PROD"]) {
    throw new Error("Personal user email and ID are not set");
  }

  const prodDb = new PrimaryModelsClient({
    datasources: {
      db: {
        url: process.env["DEV_TOOLS_PRIMARY_DATABASE_URL_PROD"],
      },
    },
  });

  const devDb = new PrimaryModelsClient({
    datasources: {
      db: {
        url: process.env["DEV_TOOLS_PRIMARY_DATABASE_URL_DEV"],
      },
    },
  });

  if (!(await isProdDb(prodDb))) {
    throw new Error("Are you sure you're using the correct database? Can't find your personal user in the Prod DB.");
  }

  if (await isProdDb(devDb)) {
    throw new Error("Dev DB is actually the Prod DB. This is critical. Please check your environment variables.");
  }

  return { prodDb, devDb };
}

async function isProdDb(supposedlyProdDb: PrimaryModelsClient) {
  const user = await supposedlyProdDb.user.findFirst({
    where: { email: process.env["DEV_TOOLS_PERSONAL_USER_EMAIL_PROD"] },
  });

  if (!user) {
    return false;
  }

  if (user.id === process.env["DEV_TOOLS_PERSONAL_USER_ID_PROD"]) {
    return true;
  }

  return false;
}
